import styles from '../../assets/styles/LandingPage/Header.module.scss';
import Testimonials from './Testimonials';
import React, { useState, useEffect } from 'react';
import MimaIsSafe from './MimaIsSafe';
import Footer from './Footer';
import Header2 from './Header2';
import { slides } from '../../utils/testimonialData';
import FeaturesNew from './FeaturesNew';
import Subscription from './Subscription';
import { BusinessController } from '../../controllers';

const LandingPage = () => {
	const [currentIndex, setCurrentIndex] = useState(0);
	const [loading, setLoading] = useState(false);
	const [autoPlay, setAutoPlay] = useState(true);
	let timeOut = null;

	const getSubscriptions = async () => {
		setLoading(true);
		await Promise.all([
			BusinessController.getAllSubscriptions(),
		]);
		setLoading(false);
	};


	useEffect(()=>{
		getSubscriptions();
	}, []);

	useEffect(() => {
			timeOut =
		autoPlay &&
		setTimeout(() => {
			toNext();
		}, 4000);
	});


		function toPrev() {
		const isFirst = currentIndex === 0
		const newIndex = isFirst ? slides.length - 1 : currentIndex - 1 
		setCurrentIndex(newIndex)
	}

	function toNext() {
		const isLast = currentIndex === slides.length - 1
		const newIndex = isLast ? 0 : currentIndex + 1 
		setCurrentIndex(newIndex)
	}

	function toSlide(slideIndex) {
		setCurrentIndex(slideIndex)
	}

	return (
		<div className={styles.main}>
			<Header2 />
			<FeaturesNew />
			<Testimonials 
				toPrev={toPrev}
				toNext={toNext}
				toSlide={toSlide}
				currentIndex={currentIndex}
				slides={slides}
				setAutoPlay={setAutoPlay}
				timeOut={timeOut}
			/>
			<Subscription loading={loading}/>
			<MimaIsSafe />
			{/*<Leads />*/}
			<Footer />
		</div>
	);
};

export default LandingPage;